import { mapActions, mapState } from 'pinia';
import * as types from '@/lib/constants/store';
import {
  useEditorStore,
  useModalStore,
} from '@/stores';

export default {
  computed: {
    ...mapState(useEditorStore, [
      'modalCanvases',
      'getModuleById',
    ]),
    hasModalCanvases() {
      return !!this.modalCanvases?.length;
    },
  },
  methods: {
    ...mapActions(useEditorStore, [
      types.UPDATE_CURRENTLY_EDITING,
      types.VIEW_MODAL_CANVAS_BY_ID,
      types.UPDATE_MODULE,
      types.CREATE_MODAL_CANVAS,
      types.LINK_MODAL_CANVAS,
    ]),
    ...mapActions(useModalStore, [
      types.OPEN_MODAL,
    ]),
    findModalCanvas(modalCanvasId) {
      return this.modalCanvases.find((canvas) => canvas.id === modalCanvasId);
    },
    attachModalCanvas(moduleInfo, modalCanvas) {
      this[types.LINK_MODAL_CANVAS]({
        modalCanvas,
        moduleInfo,
      });
      this[types.UPDATE_CURRENTLY_EDITING]({
        [moduleInfo.moduleId]: null,
      });
      this.openModalCanvas(modalCanvas.id);
    },
    openModalCanvas(modalCanvasId) {
      this[types.VIEW_MODAL_CANVAS_BY_ID](modalCanvasId);
    },
    addModalCanvas(moduleInfo) {
      const modalCanvas = this[types.CREATE_MODAL_CANVAS]({ moduleInfo });
      this.openModalCanvas(modalCanvas.id);
    },
    selectModalCanvas(moduleInfo) {
      if (this.hasModalCanvases) {
        this[types.OPEN_MODAL]({
          type: 'ModalCanvasListModal',
          moduleInfo,
        });
        return;
      }

      this.addModalCanvas(moduleInfo);
    },
  },
};
